module.exports = __webpack_public_path__ + "img/react.4ebc3773.png";